import Vue from "vue";
import Router from "vue-router";
import global from "../components/global"; //引用全局常量文件
import { getUserInfo } from "@/api/health-card";
import { getQueryString, is_weixin, is_WeixinOrAlipay } from "@/utils/index";
import Api from "../api/general-hospital/general-hospital";

// 路由配置太多，建议划分模块管理路由配置
// 核酸检测结果查询
import nucleicacidRecord from "./modules/nucleicacid-record";
// 处方流转
import recipeFlow from "./modules/recipe-flow";
// 卫生健康文联会员中心
import wlMember from "./modules/wl-member";
// 总院
import generalHospital from "./modules/general-hospital";
// 便民服务功能模块
import medicalservice from "./modules/medicalservice";

console.log("环境变量: " + process.env.NODE_ENV);
var pathBase = process.env.NODE_ENV == "release" ? "/release" : "/";
console.log("Router.base=====", pathBase);

var vm = new Vue();
Vue.use(Router);
const router = new Router({
  mode: "history",
  base: pathBase,
  routes: [
    // 互联网总医院/主入口
    ...generalHospital,
    // 诊疗服务/便民服务模块
    ...medicalservice,
    // 处方流转
    ...recipeFlow,
    // 核酸检测结果查询
    ...nucleicacidRecord,
    // 卫健委文联-会员中心
    ...wlMember
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 由于IOS宿主环境下wx.config问题，我们需要记录entryUrl
  if (to.name == "generalIndex") {
    sessionStorage.setItem("entryUrl", window.location.href);
  }

  if (to.name == "openHealthCardList" || to.name == "regHealthCard") {
    let kuaiYiToken = getQueryString("token");
    let return_uri = getQueryString("return_uri");
    if (!is_weixin() && kuaiYiToken) {
      //微信浏览器 to快医
      return_uri = encodeURIComponent(return_uri);
      if (to.name == "openHealthCardList") {
        // http://www.jkscw.com.cn、jkwin
        window.location.href =
          "http://www.jkscw.com.cn/oauth/openHealthCardList?token=" +
          kuaiYiToken +
          "&return_uri=" +
          return_uri;
        return;
      } else {
        window.location.href =
          "http://www.jkscw.com.cn/oauth/regHealthCard?token=" +
          kuaiYiToken +
          "&return_uri=" +
          return_uri;
        return;
      }
    }
  }
  console.log()
  // 用户登录鉴权
  if (!to.meta.noNeedAuth) {
    // openId,记录在session中 (互联网总医院的接口鉴权需要openId)
    var isWeixinOrAlipay = is_WeixinOrAlipay();
    console.log(from.path, to.path,isWeixinOrAlipay)
    if (from.path == "" ||(to.path == from.path && isWeixinOrAlipay == "weixin")||to.query.registerNo) {
      console.log("是来自微信内置浏览器");
      // let openId = store.state.openId;
      let local = window.location.href;
      console.log("local===", local);
      let code = getQueryString("code");
      let state = getQueryString("state");
      // 总院跳转分院携带的电子健康卡id
      let cardId = getQueryString("ehealth_card_id");
      if (cardId) {
        sessionStorage.setItem("cardId", cardId);
      }
      console.log("code1===", code);
      // if (tf_id) {
      if (code == null || code == "") {
        let appid = "wxf0d31c3bdc32a2a2";
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          appid +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_base&state=" +
          state +
          "#wechat_redirect";
      } else {
        console.log("code2===", code, "请求接口获取openId");
        // 获取openId
        if (!sessionStorage.getItem("openId")) {
          const res = await Api.getOpenId({ code: code });
          console.log(res, "获取openId");
          sessionStorage.setItem("openId", res.data);
        }
      }
      next();
      // }
    }
  }

  if (!to.name) {
    // 如果没有匹配到路由，就去默认主页
    next({
      path: "/"
    });
  } else {
    next();
  }
});
// router.afterEach((to, from) => {
//   // 由于IOS宿主环境下wx.config问题，我们需要记录entryUrl
//   if (to.name == "generalIndex") {
//     sessionStorage.setItem("entryUrl", window.location.href);
//   }
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js